import IconGame from './IconGame';
import StatisticItem from './StatisticItem';
import LinkGame from './LinkGame';
import GrandPrize from './GrandPrize';
import OtherPrize from './OtherPrize';
import Statistics from './Statistics';

export { StatisticItem, IconGame, LinkGame, GrandPrize, OtherPrize, Statistics };
